/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-empty-pattern */
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable react/jsx-no-target-blank */
import React, { useCallback, useEffect, useState } from "react";
import { AppCSS } from "../../../components";
import { Lbl } from "../../../components/labels";
import { ColDiv, RowDiv } from "../../../components/misc/misc.styled";
import { useDispatch } from "react-redux";

import { useNavigate, useParams } from "react-router-dom";
import { useAppSelector } from "../../../redux/hooks";
import { FileType } from "../../../redux/types";
import {
  setCustomerDetails,
  setCustomerProjectDetails,
  setEstimate,
} from "../../../redux/reducers";

import { GetEstimate, GetEstimateAddOns } from "../../../redux/api/estimate";
import { Estimate as EstimateType, EstimateAddOns } from "../../../redux/types/Estimate";
import { Tab, Tabs, Box, Typography } from "@mui/material";
import { ProjectIcon, TabsBox } from "./projectsDetails.styled";
import LeftArrowIcon from "../../../images/leftArrowIcon.png";
import AppLoader from "../../../components/loader/index";
import {
  INSURANCE_SCOPE_DETAILS,
  TABLABELS,
  WORKFLOWTABLABELS,
} from "../../../contants/projectDetails";
import {
  useCustomerById,
  useFetchProjectDetails,
  useProjectById,
} from "../../../apolloClient/hooks/general/fetchHook";
import { getFilesByType } from "../../../utils/project";
import { CustomerProjectDetails } from "../../../redux/types/projectDetails";
// import InsuranceScopeTap from "./InsuranceDetails/InsuranceScopeTab";
// import { ContractorDetails } from "./ContractorDetails";
// import { Invoice } from "./Invoice";
// import { Settings } from "./Settings";
import { useAccess } from "../../../hooks/useAccess";
import { CustomerDetails } from "../ProjectDetails/CustomerDetails";
import { ProgressSlider } from "../ProjectDetails/ProgressSlider";
import { ProductSystem } from "./ProductSystem";
import { PaymentMode } from "./PaymentMode";
import { InsuranceProvider } from "./InsuranceProvider";
import { ProjectPlanning } from "./ProjectPlanning";
import { MaterialSelection } from "./MaterialSelection";
import { useQuery } from "@apollo/client";
import { ProjectResponse } from "../../../types/graphQlQuery.interface";
import { GET_PROJECT_PRODUCTS } from "../../../apolloClient/operation/querys";
import { ContractorSelection } from "./ContractorSelection";
import { ScheduleInstallation } from "./ScheduleInstallation";
import { Estimate } from "./Estimate";
import { UpdateProgressInput } from "../../../redux/types";
import { UPDATE_PROGRESS } from "../../../apolloClient/operation/mutations";
import { useMutation } from "@apollo/client";
import { logEvent, PROJECT_EVENTS } from "../../../utils/amplitude";
import { ProjectModeToggle } from "../../../components/ui/ProjectModeToggle";
import { getProjectModeAccess } from "../../../utils/projectPermissions";

interface DashboardProps {}

export const ProjectWorkflow: React.FC<DashboardProps> = ({}) => {
  // Modal state for progress confirmation
  const [modalOpen, setModalOpen] = useState(false);
  const [pendingProgress, setPendingProgress] = useState<{ id: number; checked: boolean; idx: number } | null>(null);

  // Custom messages for each progress step
  const progressMessages = [
    {
      select: "Are you sure you want to mark 'Project Setup' as completed? Only proceed if the following sections are completed: Customer Details, Product System, Payment Mode, and Insurance Provider.",
      deselect: "Are you sure you want to unmark 'Project Setup' as completed? This will set the status back to incomplete.",
    },
    {
      select: "Are you sure you want to mark 'Project Planning' as completed? Only proceed if the Project Planning section is completed.",
      deselect: "Are you sure you want to unmark 'Project Planning' as completed? This will set the status back to incomplete.",
    },
    {
      select: "Are you sure you want to mark 'Ordering' as completed? Only proceed if the following sections are completed: Material Selection, Contractor Selection, Estimate Signed, Installation Scheduled, and Payment Completed.",
      deselect: "Are you sure you want to unmark 'Ordering' as completed? This will set the status back to incomplete.",
    },
    {
      select: "Are you sure you want to mark 'Construction' as completed? Only proceed if all construction activities are completed.",
      deselect: "Are you sure you want to unmark 'Construction' as completed? This will set the status back to incomplete.",
    },
    {
      select: "Are you sure you want to mark 'Completion' as completed? Only proceed if all job completion steps are done.",
      deselect: "Are you sure you want to unmark 'Completion' as completed? This will set the status back to incomplete.",
    },
  ];
  // Mutation for updating progress
  const [updateProgressMutation] = useMutation(UPDATE_PROGRESS);

  // Handler for progress checkbox change
  // Show modal before mutation
  const handleProgressChange = (progressId: number, checked: boolean, idx: number) => {
    setPendingProgress({ id: progressId, checked, idx });
    setModalOpen(true);
  };

  // Confirm and call mutation
  const handleConfirmProgress = async () => {
    if (!pendingProgress) return;
    try {
      await updateProgressMutation({
        variables: {
          input: {
            Id: pendingProgress.id,
            projectId: Number(id),
            completed: pendingProgress.checked,
          } as UpdateProgressInput,
        },
      });
      
      // Track workflow step completion
      if (pendingProgress.checked) {
        const stepNames = ['Project Setup', 'Project Planning', 'Ordering', 'Construction', 'Completion'];
        logEvent(PROJECT_EVENTS.WORKFLOW_STEP_COMPLETED, {
          project_id: id!,
          step_name: stepNames[pendingProgress.idx] || 'Unknown Step',
          step_number: pendingProgress.idx + 1
        });
      }
      
      refetch();
    } catch (error) {
      console.error("Error updating progress:", error);
    }
    setModalOpen(false);
    setPendingProgress(null);
  };

  // Cancel modal
  const handleCancelProgress = () => {
    setModalOpen(false);
    setPendingProgress(null);
  };
  let { id } = useParams();

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { customerProjectDetails, projectDetails, estimate, estimateAddOns } =
    useAppSelector((state) => state.userReducer);

  const { project, progress, docs, projectMaterials } = projectDetails;
  const [value, setValue] = useState(0);
  const [userFullName, setUsersFullName] = useState<string>("");
  const [projectId, setProjectId] = useState<string>(id);

  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [isSkip, setIsSkip] = useState<boolean>(true);
  const [insuranceFileUrl, setInsuranceFileUrl] = useState<string>("");
  const [userProjectDetails, setuserProjectDetails] =
    useState<CustomerProjectDetails>(null);

  const {
    projectDetails: projectDetailsData,
    loading: projectDetailsLoading,
    error: projectDetailsError,
    refetch,
  } = useFetchProjectDetails({
    projectId: Number(id),
  });

  const {
      data: productsData,
      loading: productsLoading,
      refetch: refetchProducts,
    } = useQuery<ProjectResponse>(GET_PROJECT_PRODUCTS, {
      variables: { id: Number(id) },
      fetchPolicy: "no-cache",
    });

  // Fetch permissions from Redux using useAppSelector
  const permissions = useAppSelector((state) => state.userReducer.permissions);

  // Check if the user has write access for the "PROJECTS" section
  const hasWriteAccess = permissions.some(
    (permission) =>
      permission.name === "PROJECTS" && permission.permission.includes("WRITE")
  );

  // Get project mode access for toggle functionality
  const projectModeAccess = getProjectModeAccess(permissions);

  // Handle mode toggle
  const handleModeToggle = (mode: 'operation' | 'manage') => {
    if (mode === 'operation') {
      // Navigate to ProjectDetails (projects route)
      navigate(`/projects/${id}`);
    }
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleRefetchProjectDetails = useCallback(() => {
    refetch();
  }, [refetch]);

  const handleRefetchProducts = useCallback(() => {
    refetchProducts();
  }, [refetchProducts]);

  // Use the global hook for access permissions
  const { loading: accessLoading } = useAccess();

  useEffect(() => {
    onFetchProjectDetails();
  }, [
    projectDetailsLoading,
    projectDetailsError,
    projectDetailsData,
    dispatch,
    handleRefetchProjectDetails,
  ]);

  useEffect(() => {
    if (!projectDetailsLoading && !projectDetailsError && projectDetailsData) {
      setIsLoading(false);
    }
  }, [
    projectDetailsLoading,
    projectDetailsError,
    projectDetailsData,
    dispatch,
  ]);

  const onFetchProjectDetails = () => {
    if (!projectDetailsLoading && !projectDetailsError && projectDetailsData) {
      dispatch(setCustomerProjectDetails(projectDetailsData));
      const userInsurancescope = getFilesByType(
        projectDetailsData.documents,
        FileType.INSURANCE
      );
      setInsuranceFileUrl(userInsurancescope[0]?.url);
      const userFullName = `${projectDetailsData.customerDetails.firstName} ${projectDetailsData.customerDetails.lastName}`;
      setUsersFullName(userFullName);
    } else if (projectDetailsError) {
      console.error("Error fetching projects:", projectDetailsError);
      setIsLoading(false);
    }
  };

  // Check if any product system requires material selection
  const anyProductRequiresMaterialSelection = projectDetailsData?.productSystem?.some((ps: any) =>
    ps.isMaterialSelectionRequired !== false
  );

  // Check if any product system requires contractor selection
  const anyProductRequiresContractorSelection = projectDetailsData?.productSystem?.some((ps: any) =>
    ps.isLaborSelectionRequired !== false
  );

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }

  const renderTabPanel = (index: number) => {
    const subSectionNames = [
      "CUSTOMER_DETAILS",
      "PRODUCT_SYSTEM",
      "PAYMENT_MODE",
      "INSURANCE_PROVIDER",
      "PROJECT_PLANNING",
      "MATERIALS",
      "CONTRACTORS",
      "INSTALLATION_DETAILS",
    ];

    const subSection = permissions
      ?.find((permission) => permission.name === "PROJECTS")
      ?.subSections?.find((sub) => sub.name === subSectionNames[index]);

    const hasWriteAccess = subSection?.permission.includes("WRITE");

    switch (index) {
      case 0:
        return (
          <CustomerDetails
            onFetchProgress={() => {}}
            project={project}
            progress={progress}
            customerDetails={customerProjectDetails.customerDetails}
          />
        );
      case 1:
        return (
          <ProductSystem
            handleRefetchProjectDetails={handleRefetchProjectDetails}
            onFetchProgress={() => {}}
            project={project}
            productData={projectDetailsData.productSystem}
            progress={progress}
            customerDetails={customerProjectDetails.customerDetails}
          />
        );
      case 2:
        return (
          <PaymentMode
            handleRefetchProducts={handleRefetchProducts}
            paymentModedata={productsData?.project}
          />
        );
      case 3:
        return (
          <InsuranceProvider
            handleRefetchProjectDetails={handleRefetchProjectDetails}
            insuranceData={projectDetailsData}
          />
        );
      case 4:
        return (
          <ProjectPlanning
            handleRefetchProjectDetails={handleRefetchProjectDetails}
            projectData={projectDetailsData}
          />
        );
      case 5:
        if (!anyProductRequiresMaterialSelection) {
          return (
            <Box sx={{ padding: "24px", textAlign: "center" }}>
              <Typography sx={{ fontSize: "16px", fontWeight: 600, color: "#1f2937", marginBottom: "12px" }}>
                Material Selection Not Required
              </Typography>
              <Typography sx={{ fontSize: "14px", color: "#6b7280", lineHeight: 1.5 }}>
                None of the product systems in this project require material selection.
                You may proceed to other steps without completing this section.
              </Typography>
            </Box>
          );
        }
        return (
          <MaterialSelection
            handleRefetchProjectDetails={handleRefetchProjectDetails}
            projectData={projectDetailsData}
          />
        );
      case 6:
        if (!anyProductRequiresContractorSelection) {
          return (
            <Box sx={{ padding: "24px", textAlign: "center" }}>
              <Typography sx={{ fontSize: "16px", fontWeight: 600, color: "#1f2937", marginBottom: "12px" }}>
                Contractor Selection Not Required
              </Typography>
              <Typography sx={{ fontSize: "14px", color: "#6b7280", lineHeight: 1.5 }}>
                None of the product systems in this project require contractor selection.
                You may proceed to other steps without completing this section.
              </Typography>
            </Box>
          );
        }
        return (
          <ContractorSelection
            handleRefetchProjectDetails={handleRefetchProjectDetails}
            projectData={projectDetailsData}
          />
        );
      case 7:
        return (
          <Estimate
            handleRefetchProjectDetails={handleRefetchProjectDetails}
            projectData={projectDetailsData}
          />
        );
      case 8:
        return (
          <ScheduleInstallation
            handleRefetchProjectDetails={handleRefetchProjectDetails}
            projectData={projectDetailsData}
          />
        );
      default:
        return null;
    }
  };

  // Filter tabs based on permissions, but always include CUSTOMER_DETAILS
  const filteredTabLabels = TABLABELS.filter((label, index) => {
    const subSectionNames = [
      "CUSTOMER_DETAILS",
      "Product System",
      "Payment Mode",
      "Insurance provider",
      "NOTES",
      "ESTIMATE",
      "INSTALLATION_DETAILS",
      "PAYMENT_DETAILS",
      "DOCUMENTS",
      "INVOICE",
      "SETTINGS",
    ];

    // Always include CUSTOMER_DETAILS (index 0)
    if (index === 0) return true;

    const subSection = permissions
      ?.find((permission) => permission.name === "PROJECTS")
      ?.subSections?.find((sub) => sub.name === subSectionNames[index]);

    return subSection?.permission.includes("READ");
  });

  if (isLoading || accessLoading) {
    return <AppLoader isLoading={isLoading || accessLoading} />;
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: "#f8fafc",
        padding: { xs: "12px", md: "24px" },
      }}
    >
      <Box sx={{ maxWidth: "1400px", margin: "0 auto" }}>
        {/* Header Section */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: { xs: 1, md: 2 },
            marginBottom: { xs: 2, md: 3 },
            backgroundColor: "white",
            padding: { xs: "16px", md: "20px" },
            borderRadius: "12px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: { xs: 1, md: 2 } }}>
            <ProjectIcon
              src={LeftArrowIcon}
              onClick={() => {
                navigate(-1);
              }}
              style={{
                cursor: "pointer",
                width: "24px",
                height: "24px",
              }}
            />
            <Box>
              <Box
                sx={{
                  fontSize: { xs: "18px", md: "24px" },
                  fontWeight: 600,
                  color: "#1f2937",
                  lineHeight: 1.2,
                }}
              >
                {userFullName}
              </Box>
              <Box
                sx={{
                  fontSize: { xs: "12px", md: "13px" },
                  color: "#6b7280",
                  marginTop: "4px",
                }}
              >
                Project ID: {projectId}
              </Box>
            </Box>
          </Box>

          {/* Toggle Button - only show if user has access to both modes */}
          {projectModeAccess.canToggleModes && (
            <ProjectModeToggle
              currentMode="manage"
              onModeChange={handleModeToggle}
            />
          )}
        </Box>

        {/* Progress Slider Section */}
        <Box
          sx={{
            marginBottom: { xs: 2, md: 3 },
            backgroundColor: "white",
            borderRadius: "12px",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            padding: { xs: "16px", md: "20px" },
          }}
        >
          <ProgressSlider
            progress={projectDetailsData?.progress}
            onProgressChange={(progressId, checked) => {
              const sorted = Array.isArray(projectDetailsData?.progress)
                ? [...projectDetailsData.progress].sort((a, b) => a.step - b.step)
                : [];
              const idx = sorted.findIndex(p => p.id === progressId);
              handleProgressChange(progressId, checked, idx);
            }}
          />
        </Box>

        {/* Progress Confirmation Modal */}
        {modalOpen && pendingProgress !== null && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              background: "rgba(0,0,0,0.25)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: 9999,
            }}
          >
            <div
              style={{
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px rgba(0,0,0,0.15)",
                padding: "24px 20px",
                width: "90%",
                maxWidth: 380,
                textAlign: "center",
              }}
            >
              <div style={{ fontSize: "18px", fontWeight: 600, marginBottom: 12, color: "#4b87ed" }}>
                Progress Confirmation
              </div>
              <div className="text-wrap" style={{ fontSize: "14px", color: "#1f2937", marginBottom: 20, lineHeight: "1.5" }}>
                {pendingProgress.checked
                  ? (progressMessages[pendingProgress.idx]?.select || "Are you sure you want to update this progress?")
                  : (progressMessages[pendingProgress.idx]?.deselect || "Are you sure you want to update this progress?")}
              </div>
              <div style={{ display: "flex", justifyContent: "center", gap: 12 }}>
                <button
                  style={{
                    padding: "10px 20px",
                    background: "#4b87ed",
                    color: "#fff",
                    border: "none",
                    borderRadius: 6,
                    fontWeight: 500,
                    fontSize: "14px",
                    cursor: "pointer",
                  }}
                  onClick={handleConfirmProgress}
                >
                  Yes
                </button>
                <button
                  style={{
                    padding: "10px 20px",
                    background: "#f3f4f6",
                    color: "#6b7280",
                    border: "none",
                    borderRadius: 6,
                    fontWeight: 500,
                    fontSize: "14px",
                    cursor: "pointer",
                  }}
                  onClick={handleCancelProgress}
                >
                  No
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Tabs and Content */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            gap: { xs: 2, md: 3 },
          }}
        >
          {/* Sidebar Navigation - Desktop */}
          <Box
            sx={{
              display: { xs: "none", md: "block" },
              width: "280px",
              flexShrink: 0,
            }}
          >
            <Box
              sx={{
                backgroundColor: "white",
                borderRadius: "12px",
                boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
                padding: "16px",
                position: "sticky",
                top: "24px",
                maxHeight: "calc(100vh - 48px)",
                overflowY: "auto",
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                orientation="vertical"
                TabIndicatorProps={{
                  style: {
                    display: "none",
                  },
                }}
                aria-label="workflow tabs"
                variant="scrollable"
                sx={{
                  "& .MuiTabs-flexContainer": {
                    gap: "4px",
                  },
                }}
              >
                {WORKFLOWTABLABELS?.map((label, index) => (
                  <Tab
                    key={index}
                    label={label}
                    {...a11yProps(index)}
                    sx={{
                      alignItems: "flex-start",
                      textAlign: "left",
                      padding: "12px 16px",
                      minHeight: "auto",
                      fontSize: "14px",
                      fontWeight: 500,
                      color: "#4b5563",
                      borderRadius: "8px",
                      textTransform: "none",
                      transition: "all 0.2s",
                      "&:hover": {
                        backgroundColor: "#f3f4f6",
                      },
                      "&.Mui-selected": {
                        color: "white",
                        backgroundColor: "#4b87ed",
                      },
                    }}
                  />
                ))}
              </Tabs>
            </Box>
          </Box>

          {/* Mobile Tabs - Horizontal Scrollable */}
          <Box
            sx={{
              display: { xs: "block", md: "none" },
              backgroundColor: "white",
              borderRadius: "12px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              padding: "8px",
              overflowX: "auto",
              WebkitOverflowScrolling: "touch",
              "&::-webkit-scrollbar": {
                display: "none",
              },
            }}
          >
            <Tabs
              value={value}
              onChange={handleChange}
              variant="scrollable"
              scrollButtons={false}
              TabIndicatorProps={{
                style: {
                  display: "none",
                },
              }}
              aria-label="workflow tabs"
              sx={{
                minHeight: "auto",
                "& .MuiTabs-flexContainer": {
                  gap: "8px",
                },
              }}
            >
              {WORKFLOWTABLABELS?.map((label, index) => (
                <Tab
                  key={index}
                  label={label}
                  {...a11yProps(index)}
                  sx={{
                    minHeight: "auto",
                    padding: "8px 16px",
                    fontSize: "13px",
                    fontWeight: 500,
                    color: "#4b5563",
                    borderRadius: "8px",
                    textTransform: "none",
                    whiteSpace: "nowrap",
                    minWidth: "auto",
                    border: value === index ? "none" : "1px solid #e5e7eb",
                    "&.Mui-selected": {
                      color: "white",
                      backgroundColor: "#4b87ed",
                    },
                  }}
                />
              ))}
            </Tabs>
          </Box>

          {/* Content Area */}
          <Box
            sx={{
              flex: 1,
              backgroundColor: "white",
              borderRadius: "12px",
              boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
              padding: { xs: "16px", md: "24px" },
              minHeight: { xs: "auto", md: "calc(100vh - 200px)" },
              maxHeight: { xs: "none", md: "calc(100vh - 200px)" },
              overflowY: "auto",
            }}
          >
            {renderTabPanel(value)}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
